import React from "react";
import TopNav from "../components/TopNav";

import { VsiContentSection, VsiH4 } from "../styled/App.styled";
import { Card, Container, Spinner } from "reactstrap";
import { Routes, Route, Navigate } from "react-router-dom";

import { allRoutes } from "../utils/routes";
import BreadCrumbs from "./BreadCrumbs";
import { useVsiAppContext } from "../stores/VsiApp";

import ReportErrorBoundary from "../boundaries/reports/ReportErrorBoundary";
import ReportUtilityBar from "./ReportUtilityBar";
import { ReportProvider } from "../stores/Report";

const nonReportContexts = ['home', 'settings', 'admin'];

export default function VsiContent() {
  const { sidebarOpen, user } = useVsiAppContext();

  return (
    <VsiContentSection $isOpen={sidebarOpen}>
      <TopNav />
      <BreadCrumbs/>
      <Container className={"pb-2"} fluid>
        <Routes>
          {allRoutes.map(
            (route, index) => {
              const {
                context,
                path,
                title,
                roles,
                Component
              } = route;
              if (roles && !roles.includes(user.role)) {
                return null
              }
              return (
                <Route
                  path={path}
                  key={`route-${title}-${index}`}
                  element={
                    <ReportErrorBoundary key={`err-boundary-${title}-${index}`} title={title}>
                      <ReportProvider title={title} context={context}>
                        {!nonReportContexts.includes(context?.toLowerCase?.()) ? (
                          <>
                            <Component title={title} context={context} route={route}/>
                            <ReportUtilityBar route={route}/>
                          </>
                        ) : (
                          <Component title={title} context={context} roles={roles}/>
                        )}
                      </ReportProvider>
                    </ReportErrorBoundary>
                  }
                />
              )
            })}
          <Route path="*" element={<Navigate to="/home" replace />} />
        </Routes>
      </Container>
    </VsiContentSection>
  );
}
